import React from "react";
import { Avatar, Grid, Typography } from "@mui/material";
import { GoArrowUpRight } from "react-icons/go";
import { useParams } from "react-router-dom";
import { useGetContractManagementClaimOrderQuery } from "store/slices/apis/contractManagementDashboardSlice";




const Claims = (props) => {

  const { RaisedType } = props
 
  const { projectId } = useParams();

  const params = {
    projectId: projectId,
    raisedType: RaisedType
  }
  const { data, isLoading, isFetching } = useGetContractManagementClaimOrderQuery(params)

  const items = [
  {
    name: "Count",
    value: data?.data.totalCount,
  },
  {
    name: "Value",
    value: `₹ ${data?.data.totalValue}`,
  },
  {
    name: "Impact",
    value: `${data?.data.impactPercentage}%`,
  },
];

  return (
    <Grid container size={12} sx={{ pb: 1 }}>
      <Grid
        size={12}
        container
        spacing={2}
        sx={{ p: 1.5, alignItems: "center" }}
      >
        <Avatar
          sx={{
            bgcolor: "#F2F2F7",
            width: "40px",
            height: "40px",
            border: "1px solid #fff",
          }}
        >
          <GoArrowUpRight
            style={{
              color: "#0088FF",
              fontSize: "20px",
              cursor: "pointer",
            }}
          />
        </Avatar>
        <Typography
          sx={{
            fontFamily: "Outfit, sans-serif",
            fontWeight: 700,
            fontSize: "26px",
            letterSpacing: "0px",
            lineHeight: "100%",
            color: "#566577",
          }}
        >
          Claims
        </Typography>
      </Grid>
      <Grid container size={12} sx={{ bgcolor: "#EBEFFF", p: 1.5 }}>
        {items.map((item, index) => (
          <Grid
            size={4}
            key={index}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography
              sx={{
                fontFamily: "Outfit, sans-serif",
                fontWeight: 500,
                fontSize: "20px",
                letterSpacing: "0px",
                lineHeight: "100%",
                color: "#0E233C",
              }}
            >
              {item.value}
            </Typography>
            <Typography
              sx={{
                fontFamily: "Outfit, sans-serif",
                fontWeight: 400,
                fontSize: "17px",
                letterSpacing: "0px",
                lineHeight: "25px",
                color: "#566577",
              }}
            >
              {item.name}
            </Typography>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};

export default Claims;
